import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dolgu-islemleri-yuz-liftingi-saglar-mi/page.tsx");
